import type {
  UserUserInboxListMessagesParams,
  UserInboxMarkReadInput,
  UserInboxMarkAllReadInput,
} from '../api'
import { api } from '../api'

const userInboxListMessages = async (data: UserUserInboxListMessagesParams) => {
  return await api.v1.userUserInboxListMessages(data)
}

const userInboxMarkAsRead = async (data: UserInboxMarkReadInput) => {
  return await api.v1.userUserInboxMarkAsRead(data)
}

const userInboxMarkAllAsRead = async (data: UserInboxMarkAllReadInput) => {
  return await api.v1.userUserInboxMarkAllAsRead(data)
}

export default {
  userInboxListMessages,
  userInboxMarkAsRead,
  userInboxMarkAllAsRead,
}
